import React, { useState } from 'react';
import { FiX, FiEdit2, FiSmile, FiArrowRight } from 'react-icons/fi';
import { toast } from 'react-hot-toast';
import cartService from '../api/cart.service';

function RequestForCustomization({ sectionName }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (formData) => {
    if (!formData.message.trim()) {
      toast.dismiss();
      toast.error('Message cannot be empty!');
      return;
    }

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(12, 0, 0, 0);

    const payload = {
      item_type: sectionName.toLowerCase(),
      event_date: tomorrow.toISOString(),
      name: `${sectionName} section`,
      description: formData.message,
    };

    setIsLoading(true);
    try {
      const response = await cartService.createCustomizationItem(payload);

      if (response.success) {
        toast.dismiss();
        toast.success('Customization item added successfully!');
        setIsModalOpen(false);
      } else {
        toast.dismiss();
        toast.error(response.message || 'Failed to add customization item.');
      }
    } catch (error) {
      toast.dismiss();
      toast.error('An error occurred while adding the customization item.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        className='bg-white rounded-full text-black focus:outline-none border border-gray-300 text-sm transition-shadow duration-300'
      >
        <div className='inline-flex text-nowrap items-center hover:cursor-pointer space-x-2 px-4 py-1 rounded-full hover:bg-gray-100 focus:ring-2 focus:ring-blue-500'>
          <span>Request for customization</span>
          <FiArrowRight className='text-gray-700 text-base transition-transform transform hover:translate-x-1' />
        </div>
      </div>

      {isModalOpen && (
        <CustomizationModal
          sectionName={sectionName}
          onClose={() => setIsModalOpen(false)}
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      )}
    </>
  );
}

const CustomizationModal = ({ onClose, onSubmit, sectionName, isLoading }) => {
  const [formData, setFormData] = useState({
    foodSection: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className='fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center md:p-6 p-2 z-50'>
      <div className='bg-[#EDEDED] rounded-lg w-full max-w-md md:p-10 p-6 relative'>
        <button
          onClick={onClose}
          className='absolute right-4 top-4 text-gray-500 hover:text-gray-700'
        >
          <FiX size={24} />
        </button>

        <h2 className='md:text-2xl text-lg font-semibold text-center text-indigo-900 mb-8'>
          Request for customization
        </h2>

        <form onSubmit={handleSubmit} className='space-y-6'>
          <div className='bg-white rounded-lg p-4 flex items-center space-x-3'>
            <FiEdit2 className='text-gray-400' size={20} />
            <input
              type='text'
              placeholder={`${sectionName} section`}
              className='w-full bg-transparent outline-none text-gray-900 placeholder-gray-900'
              value={formData.foodSection}
              onChange={(e) =>
                setFormData({ ...formData, foodSection: e.target.value })
              }
              disabled
            />
          </div>

          <div className='bg-white rounded-lg p-4 flex space-x-3'>
            <FiSmile className='text-gray-400 mt-1' size={20} />
            <textarea
              placeholder='Message for Customization'
              className='w-full bg-transparent outline-none text-gray-600 placeholder-gray-400 resize-none min-h-[120px]'
              value={formData.message}
              onChange={(e) =>
                setFormData({ ...formData, message: e.target.value })
              }
            />
          </div>

          <div className='flex justify-center'>
            <button
              type='submit'
              className={`bg-buttonprimary text-white font-semibold py-3 px-6 rounded-md transition duration-200 ${
                isLoading
                  ? 'opacity-60 cursor-not-allowed'
                  : 'hover:bg-buttonhoverPrimary'
              }`}
              disabled={isLoading}
            >
              {isLoading ? 'Submitting...' : 'Request & Add to cart'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestForCustomization;
